import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_public } from '../API/Api';

const ShortLinkRedirect = () => {
  const { shortCode } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // 调用API获取短链信息 - 使用不需要认证的API
        const response = await API_public.get(`/share/short?short=${shortCode}`);

        if (response?.data?.origin) {
          // 直接导航到目标路由
          navigate(response.data.origin);
        } else {
          console.error('响应数据结构:', {
            hasResponse: !!response,
            hasData: !!response?.data,
            hasOrigin: !!response?.data?.origin,
            fullResponse: response,
          });
          setError('短链格式错误');
          setTimeout(() => {
            navigate('/404');
          }, 1000);
        }
      } catch (error) {
        console.error('短链重定向失败:', error);
        setError('短链不存在或已过期');
        setTimeout(() => {
          navigate('/404');
        }, 2000);
      } finally {
        setIsLoading(false);
      }
    };

    if (shortCode) {
      handleRedirect();
    } else {
      setError('无效的短链');
      setTimeout(() => {
        navigate('/404');
      }, 2000);
    }
  }, [shortCode, navigate]);

  if (isLoading) {
    return (
      <div className='flex items-center justify-center min-h-screen w-full bg-white'>
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4'></div>
          <p className='text-lg text-gray-600'>Opening...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='flex items-center justify-center min-h-screen w-full bg-white'>
        <div className='text-center'>
          <div className='text-red-500 text-6xl mb-4'>⚠️</div>
          <p className='text-lg text-gray-600 mb-2'>{error}</p>
          <p className='text-sm text-gray-500'>Redirecting to homepage...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default ShortLinkRedirect;
